import { render } from "./basicInform.vue?vue&type=template&id=c3459efa&scoped=true"
import script from "./basicInform.vue?vue&type=script&lang=js"
export * from "./basicInform.vue?vue&type=script&lang=js"

import "./basicInform.vue?vue&type=style&index=0&id=c3459efa&lang=scss&scoped=true"
import "./basicInform.vue?vue&type=style&index=1&id=c3459efa&lang=scss&scoped=true"
import "./basicInform.vue?vue&type=style&index=2&id=c3459efa&lang=scss"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3459efa"]])

export default __exports__